import {
  FETCH_MARGIN_CONFIG_REQUEST,
  FETCH_MARGIN_CONFIG_SUCCESS,
  FETCH_MARGIN_CONFIG_FAILURE
} from '../actions/margin';

const initialState = {
  marginConfig: {},
  loading: false,
  error: null,
  lastFetchTime: null
};

const marginReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MARGIN_CONFIG_REQUEST:
      console.log('Margin config: Starting fetch...');
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_MARGIN_CONFIG_SUCCESS:
      console.log('Margin config: Fetch successful', {
        configKeys: action.payload ? Object.keys(action.payload) : [],
        timestamp: new Date().toISOString()
      });
      return {
        ...state,
        marginConfig: action.payload,
        loading: false,
        error: null,
        lastFetchTime: Date.now()
      };

    case FETCH_MARGIN_CONFIG_FAILURE:
      console.error('Margin config: Fetch failed', action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
        marginConfig: {}
      };

    case 'CLEAR_MARGIN_CONFIG_ERROR':
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default marginReducer; 